"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
const bytes_1 = __importDefault(require("bytes"));
const APIErrors_1 = require("./resources/APIErrors");
const APITasks_1 = require("./resources/APITasks");
const APIError_1 = require("./APIError");
const ClientSummaryInfo_1 = require("./ClientSummaryInfo");
const Download_1 = require("./Download");
const FileOps_1 = require("./FileOps");
const FSIServerClientInterface_1 = require("./FSIServerClientInterface");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const InputChecks_1 = require("./InputChecks");
const ListLocal_1 = require("./ListLocal");
const MetaDataClient_1 = require("./MetaDataClient");
const QueueItem_1 = require("./QueueItem");
const TaskController_1 = require("./TaskController");
const TaskProgress_1 = require("./TaskProgress");
const index_1 = require("./index");
const LogLevel_1 = require("./LogLevel");
const QueueProgress_1 = require("./QueueProgress");
const modeNode = FSIServerClientUtils_1.FSIServerClientUtils.GET_MODE_NODE();
class Queue {
    constructor(classInit, opts) {
        this.classInit = classInit;
        this.results = [];
        this.queueMethods = {};
        this.currentBatch = {
            clientInfo: new ClientSummaryInfo_1.ClientSummaryInfo(),
            connectorTypes: {},
            entries: [],
            lists: []
        };
        this.options = {
            continueOnError: false
        };
        this.nQueuePos = 0;
        this.arQueueItems = [];
        this.bRunning = false;
        this.bError = false;
        this.canceled = false;
        this.aborted = false;
        this.arErrors = [];
        this.client = classInit.client;
        this.com = classInit.com;
        this.queueId = this.client.getNewQueueId();
        this.taskController = new TaskController_1.TaskController(this.classInit, "queue #" + this.queueId);
        if (opts !== undefined) {
            this.options = opts;
        }
        if (this.options.continueOnError === undefined) {
            this.options.continueOnError = false;
        }
        if (this.options.fnProgress === false || this.options.fnProgress === undefined) {
            this.fnProgress = {
                ctx: this,
                fn: Queue.defaultProgress
            };
        }
        else {
            this.fnProgress = this.options.fnProgress;
        }
        if (this.options.fnPrompt) {
            this.fnPrompt = this.options.fnPrompt;
        }
        else if (this.options.fnPrompt === undefined) {
            this.fnPrompt = this.options.fnPrompt = this.client.getPromptFunction();
        }
        else if (!this.options.fnPrompt) {
            this.fnPrompt = undefined;
        }
        this.queueProgress = new QueueProgress_1.QueueProgress(this);
        this.iCurrentItem = this.queueProgress.currentItem;
        this.abortController = this.com.getNewAbortController();
        this.batchTask = {
            length: 0,
            lockProgress: false,
            position: 0,
            revPosition: 0,
            running: false,
            taskName: ""
        };
        const client = this.client;
        this.queueMethods = {
            "addDirectoryContent": { "ctx": this, "fn": this.runAddDirectoryContent },
            "addEntries": { "ctx": this, "fn": this.runAddEntries },
            "addEntryObjects": { "ctx": this, "fn": this.runAddEntryObjects },
            "batchCopy": { "ctx": this, "fn": this.runBatchCopy },
            "batchDelete": { "ctx": this, "fn": this.runBatchDelete },
            "batchDownload": { "ctx": this, "fn": this.runBatchDownLoad },
            "batchGetMetaData": { "ctx": this, "fn": this.runBatchGetMetaData },
            "batchMove": { "ctx": this, "fn": this.runBatchMove },
            "batchReimport": { "ctx": this, "fn": this.runBatchReimport },
            "batchRename": { "ctx": this, "fn": this.runBatchRename },
            "batchSendServiceCommands": { "ctx": this, "fn": this.runBatchSendServiceCommands },
            "batchSetMetaData": { "ctx": this, "fn": this.runBatchSetMetaData },
            "batchUpload": { "ctx": this, "fn": this.runBatchUpload },
            "changePassword": { "ctx": client, "fn": client.changePassword },
            "changeUser": { "ctx": client, "fn": client.changeUser },
            "clearList": { "ctx": this, "fn": this.runClearList },
            "copyDirectory": { "ctx": client, "fn": client.copyDirectory },
            "copyDirectoryContent": { "ctx": client, "fn": client.copyDirectoryContent },
            "copyFile": { "ctx": client, "fn": client.copyFile },
            "createDirectory": { "ctx": client, "fn": client.createDirectory },
            "deleteDirectory": { "ctx": client, "fn": client.deleteDirectory },
            "deleteFile": { "ctx": client, "fn": client.deleteFile },
            "deleteMetaData": { "ctx": client, "fn": client.deleteMetaData },
            "download": { "ctx": client, "fn": client.download },
            "downloadICCProfile": { "ctx": client, "fn": client.downloadICCProfile },
            "getMetaData": { "ctx": client, "fn": client.getMetaData },
            "getUserList": { "ctx": client, "fn": client.getUserList },
            "listLocal": { "ctx": client, "fn": client.listLocal },
            "listServer": { "ctx": client, "fn": client.listServer },
            "logBatchContent": { "ctx": this, "fn": this.runLogBatchContent },
            "logBatchContentSummary": { "ctx": this, "fn": this.runLogBatchContentSummary },
            "login": { "ctx": client, "fn": client.login },
            "logout": { "ctx": client, "fn": client.logout },
            "moveFile": { "ctx": client, "fn": client.moveFile },
            "moveDirectory": { "ctx": client, "fn": client.moveDirectory },
            "reImportDir": { "ctx": client, "fn": client.reImportDir },
            "reImportFile": { "ctx": client, "fn": client.reImportFile },
            "renameDirectory": { "ctx": client, "fn": client.renameDirectory },
            "renameFile": { "ctx": client, "fn": client.renameFile },
            "restoreMetaData": { "ctx": client, "fn": client.restoreMetaData },
            "runCustomTask": { "ctx": this, "fn": this.runCustomTask },
            "sendServiceCommand": { "ctx": client, "fn": client.sendServiceCommand },
            "setMetaData": { "ctx": client, "fn": client.setMetaData },
            "upload": { "ctx": client, "fn": client.upload }
        };
    }
    static defaultProgress() {
    }
    static doRunLogBatchContent(self) {
        const logLevel = LogLevel_1.LogLevel.info;
        if (self.currentBatch.entries.length > 0) {
            const nTotal = self.currentBatch.entries.length;
            for (let i = 0; i < nTotal; i++) {
                self.abortController.throwIfAborted();
                const entry = self.currentBatch.entries[i];
                let line = (i + 1) + "/" + nTotal + " " + entry.type.toUpperCase() + ": " + entry.path;
                if (entry.type === "file") {
                    line += " " + self.com.taskSupplier.getLocaleFloat((0, bytes_1.default)(entry.size, { thousandsSeparator: ",", unitSeparator: " " }));
                    line += " importState: " + entry.importStatus;
                }
                self.taskController.log(logLevel, line);
                if (entry.metaData) {
                    self.taskController.log(logLevel, entry.metaData.toString());
                }
            }
        }
        else {
            self.taskController.logTask(LogLevel_1.LogLevel.info, APITasks_1.APITasks.queueEmpty);
        }
        self.taskController.onPromiseOk();
        self.onSingleStepBatchDone();
        return true;
    }
    static doRunLogBatchContentSummary(self) {
        if (self.currentBatch.clientInfo.entryCount > 0) {
            const level = LogLevel_1.LogLevel.info;
            self.taskController.log(level, self.com.taskSupplier.get(APITasks_1.APITasks.queueContentSummary).getMessage());
            self.taskController.log(level, "Entries: " + self.com.taskSupplier.niceInt(self.currentBatch.clientInfo.entryCount));
            self.taskController.log(level, "Files: " + self.com.taskSupplier.niceInt(self.currentBatch.clientInfo.fileCount));
            self.taskController.log(level, "Directories: " + self.com.taskSupplier.niceInt(self.currentBatch.clientInfo.directoryCount));
            let sz = (0, bytes_1.default)(self.currentBatch.clientInfo.totalSize);
            sz += " (" + self.com.taskSupplier.niceInt(self.currentBatch.clientInfo.totalSize) + " bytes)";
            self.taskController.log(level, "Total size: " + sz);
            for (let i = 0; i < 6; i++) {
                self.taskController.log(level, "Import state " + i + ": "
                    + self.com.taskSupplier.niceInt(self.currentBatch.clientInfo.importStates[i]));
            }
        }
        else {
            self.taskController.logTask(LogLevel_1.LogLevel.info, APITasks_1.APITasks.queueEmpty);
        }
        self.onSingleStepBatchDone();
        return true;
    }
    login(username, password, options = {}) {
        InputChecks_1.InputChecks.LOGIN(username, password);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("login", [username, password, options, this.taskController]);
    }
    logout(options = {}) {
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("logout", [options, this.taskController]);
    }
    changePassword(currentPassword, newPassWord, options = {}) {
        InputChecks_1.InputChecks.PATH(currentPassword, "currentPassword");
        InputChecks_1.InputChecks.PATH(newPassWord, "newPassWord");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("changePassword", [currentPassword, newPassWord, options, this.taskController]);
    }
    changeUser(user, options = {}) {
        InputChecks_1.InputChecks.PATH(user, "user");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("changeUser", [user, options, this.taskController]);
    }
    getUserList(options = {}) {
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("getUserList", [options, this.taskController]);
    }
    listServer(path, options = {}) {
        InputChecks_1.InputChecks.LIST_SERVER(path, options);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("listServer", [path, options, this.taskController]);
    }
    listLocal(path, options = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("listLocal", [path, options, this.taskController]);
    }
    createDirectory(path, copyOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_OBJECT(copyOptions, "copyOptions");
        this.setDefaultOptionFunction(copyOptions);
        this.addTask("createDirectory", [path, copyOptions, this.taskController]);
    }
    renameFile(oldPath, newPath, copyOptions = {}) {
        InputChecks_1.InputChecks.RENAME(oldPath, newPath);
        InputChecks_1.InputChecks.IS_OBJECT(copyOptions, "copyOptions");
        this.setDefaultOptionFunction(copyOptions);
        this.addTask("renameFile", [oldPath, newPath, copyOptions, this.taskController]);
    }
    renameDirectory(oldPath, newPath, copyOptions = {}) {
        InputChecks_1.InputChecks.RENAME(oldPath, newPath);
        InputChecks_1.InputChecks.IS_OBJECT(copyOptions, "copyOptions");
        this.setDefaultOptionFunction(copyOptions);
        this.addTask("renameDirectory", [oldPath, newPath, copyOptions, this.taskController]);
    }
    reImportDir(path, image = true, metaData = true, httpOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.RE_IMPORT(image, metaData);
        InputChecks_1.InputChecks.IS_OBJECT(httpOptions, "httpOptions");
        this.setDefaultOptionFunction(httpOptions);
        this.addTask("reImportDir", [path, image, metaData, httpOptions, this.taskController]);
    }
    reImportFile(path, image = true, metaData = true, httpOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.RE_IMPORT(image, metaData);
        InputChecks_1.InputChecks.IS_OBJECT(httpOptions, "httpOptions");
        this.setDefaultOptionFunction(httpOptions);
        this.addTask("reImportFile", [path, image, metaData, httpOptions, this.taskController]);
    }
    deleteFile(path, httpOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_OBJECT(httpOptions, "httpOptions");
        this.setDefaultOptionFunction(httpOptions);
        this.addTask("deleteFile", [path, httpOptions, this.taskController]);
    }
    deleteDirectory(path, httpOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_OBJECT(httpOptions, "httpOptions");
        this.setDefaultOptionFunction(httpOptions);
        this.addTask("deleteDirectory", [path, httpOptions, this.taskController]);
    }
    getMetaData(path, options = {}) {
        InputChecks_1.InputChecks.GET_META_DATA(path, options);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("getMetaData", [path, options, this.taskController]);
    }
    setMetaData(path, data, service = "file", options = {}) {
        InputChecks_1.InputChecks.META_DATA(path, data, service);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("setMetaData", [path, data, service, options, this.taskController]);
    }
    sendServiceCommand(src, service, command, options = {}) {
        InputChecks_1.InputChecks.PATH(src, "src");
        InputChecks_1.InputChecks.PATH(service, "service");
        InputChecks_1.InputChecks.PATH(command, "command");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("sendServiceCommand", [src, service, command, options, this.taskController]);
    }
    deleteMetaData(path, data, service = "file", options = {}) {
        InputChecks_1.InputChecks.META_DATA(path, data, service);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("setMetaData", [path, data, service, options, this.taskController]);
    }
    restoreMetaData(path, data, service = "file", options = {}) {
        InputChecks_1.InputChecks.META_DATA(path, data, service);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("setMetaData", [path, data, service, options, this.taskController]);
    }
    copyDirectory(path, toPath, listOptions = {}) {
        InputChecks_1.InputChecks.COPY(path, toPath, listOptions);
        this.setDefaultOptionFunction(listOptions);
        this.addTask("copyDirectory", [path, toPath, listOptions, this.taskController, this]);
    }
    copyDirectoryContent(path, toPath, listOptions = {}) {
        InputChecks_1.InputChecks.COPY(path, toPath, listOptions);
        this.setDefaultOptionFunction(listOptions);
        this.addTask("copyDirectoryContent", [path, toPath, listOptions, this.taskController, this]);
    }
    copyFile(path, toPath, copyOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.PATH(toPath, "toPath");
        InputChecks_1.InputChecks.IS_OBJECT(copyOptions, "copyOptions");
        this.setDefaultOptionFunction(copyOptions);
        this.addTask("copyFile", [path, toPath, copyOptions, this.taskController]);
    }
    moveFile(path, toPath, copyOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.PATH(toPath, "toPath");
        InputChecks_1.InputChecks.IS_OBJECT(copyOptions, "copyOptions");
        this.setDefaultOptionFunction(copyOptions);
        this.addTask("moveFile", [path, toPath, copyOptions, this.taskController]);
    }
    moveDirectory(path, toPath, copyOptions = {}) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.PATH(toPath, "toPath");
        InputChecks_1.InputChecks.IS_OBJECT(copyOptions, "copyOptions");
        this.setDefaultOptionFunction(copyOptions);
        this.addTask("moveDirectory", [path, toPath, copyOptions, this.taskController]);
    }
    download(pathOrEntry, targetPath, options = {}) {
        InputChecks_1.InputChecks.OBJECT_OR_STRING(pathOrEntry, "pathOrEntry");
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        if (options && options.archiveType)
            InputChecks_1.InputChecks.ARCHIVE_TYPE(options.archiveType);
        this.setDefaultOptionFunction(options);
        this.addTask("download", [pathOrEntry, targetPath, options, this.taskController]);
    }
    downloadICCProfile(pathOrEntry, targetPath, options = {}) {
        InputChecks_1.InputChecks.OBJECT_OR_STRING(pathOrEntry, "pathOrEntry");
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        if (options && options.archiveType)
            InputChecks_1.InputChecks.ARCHIVE_TYPE(options.archiveType);
        this.setDefaultOptionFunction(options);
        this.addTask("downloadICCProfile", [pathOrEntry, targetPath, options, this.taskController]);
    }
    upload(sourcePath, targetPath, options = {}) {
        InputChecks_1.InputChecks.PATH(sourcePath, "sourcePath");
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        this.addTask("upload", [sourcePath, targetPath, options, this.taskController]);
    }
    abort() {
        return this.abortController.abort();
    }
    logBatchContentSummary() {
        this.addTask("logBatchContentSummary");
    }
    addDirectoryContent() {
        this.addTask("addDirectoryContent", [{}]);
    }
    addEntries(paths, options = { recursive: true }) {
        InputChecks_1.InputChecks.STRING_ARRAY(paths, "paths");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("addEntries", [paths, options]);
    }
    addEntryObjects(entries, options = {}, addOptions = {}) {
        InputChecks_1.InputChecks.OBJECT_ARRAY(entries, "paths");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        InputChecks_1.InputChecks.IS_OBJECT(addOptions, "addOptions");
        this.addTask("addEntryObjects", [entries, options, addOptions]);
    }
    batchRename(fnRename) {
        InputChecks_1.InputChecks.IS_FN(fnRename, "fnRename");
        this.addTask("batchRename", [fnRename]);
    }
    batchMove(newPath) {
        InputChecks_1.InputChecks.PATH(newPath);
        this.addTask("batchMove", [newPath]);
    }
    batchReimport(image = true, metaData = true, httpOptions) {
        InputChecks_1.InputChecks.RE_IMPORT(image, metaData);
        this.addTask("batchReimport", [image, metaData, httpOptions]);
    }
    batchGetMetaData(options = {}) {
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchGetMetaData", [options]);
    }
    batchSetMetaData(data, options = {}) {
        InputChecks_1.InputChecks.FN_OBJECT_OR_FUNCTION(data, "data");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchSetMetaData", [data, "saveMetaData", options]);
    }
    batchDeleteMetaData(data, options = {}) {
        InputChecks_1.InputChecks.FN_OBJECT_OR_FUNCTION(data, "data");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchSetMetaData", [data, "deleteMetaData", options]);
    }
    batchRestoreMetaData(data, options = {}) {
        InputChecks_1.InputChecks.FN_OBJECT_OR_FUNCTION(data, "data");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchSetMetaData", [data, "restoreMetaData", options]);
    }
    batchCopy(targetPath, options = {}) {
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchCopy", [targetPath, options]);
    }
    batchDelete(options = {}) {
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchDelete", [options]);
    }
    batchDownload(targetPath, options = {}) {
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchDownload", [targetPath, options]);
    }
    batchDownloadICCProfiles(targetPath, options = {}) {
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        options.getICCProfile = true;
        this.addTask("batchDownload", [targetPath, options]);
    }
    batchUpload(targetPath, options = {}) {
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchUpload", [targetPath, options]);
    }
    batchSendServiceCommands(service, command, options = {}) {
        InputChecks_1.InputChecks.STRING(service, "service");
        InputChecks_1.InputChecks.STRING(command, "command");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.addTask("batchSendServiceCommands", [service, command, options]);
    }
    logBatchContent() {
        this.addTask("logBatchContent");
    }
    clearList() {
        this.addTask("clearList");
    }
    runCustom(scope, fn, ...args) {
        InputChecks_1.InputChecks.IS_OBJECT(scope, "scope");
        InputChecks_1.InputChecks.IS_FN(fn, "fn");
        if (typeof (args) !== "object" || typeof (args.concat) !== "function")
            args = [];
        args.unshift(fn);
        args.unshift(scope);
        this.addTask("runCustomTask", args);
    }
    getAborted() {
        return this.canceled;
    }
    addItemsFromDataTransferItemList(dataTransferItemList, options = {}) {
        InputChecks_1.InputChecks.IS_OBJECT(dataTransferItemList, "dataTransferItemList");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        this.setDefaultOptionFunction(options);
        if (this.bRunning) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.queueRunning);
        }
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.readDataTransfer);
        this.queueProgress.currentTask = this.taskController.getCurrentTask();
        this.queueProgress.timeStart = FSIServerClientUtils_1.FSIServerClientUtils.NOW();
        this.queueProgress.length = 1;
        this.queueProgress.pos = 1;
        this.queueProgress.percent = 0;
        this.queueProgress.task.pos = 0;
        this.queueProgress.task.length = 1;
        this.queueProgress.task.percent = 0;
        this.batchTask.position = 0;
        this.addProgressCallbacks(options);
        const self = this;
        return new Promise((resolve, reject) => {
            new ListLocal_1.ListLocal(self.classInit, this.taskController).addItemsFromDataTransferItemList(dataTransferItemList, options)
                .then(ld => {
                self.appendListData(ld);
                resolve(ld);
            })
                .catch(reject);
        });
    }
    onProgress(prg) {
        this.batchTask.length = prg.task.length;
        this.batchTask.position = prg.task.pos;
        if (this.batchTask.length < 1 || this.batchTask.position === this.batchTask.length) {
            this.queueProgress.task.percent = 100;
        }
        else {
            this.queueProgress.task.percent = 100 * this.batchTask.position / this.batchTask.length;
        }
        this.runProgress(prg);
    }
    getProgressData() {
        return this.queueProgress;
    }
    onTaskProgress(tPrg) {
        if (this.canceled)
            return;
        this.queueProgress.currentTask.setSubTaskInstance(tPrg.currentTask);
        this.queueProgress.task.currentTask = tPrg.currentTask;
        if (this.batchTask.length > 0) {
            this.queueProgress.task.percent = 100 * (this.batchTask.position + tPrg.percent / 100) / this.batchTask.length;
        }
        else {
            this.queueProgress.task.percent = tPrg.percent;
        }
        if (tPrg.bytesTotal) {
            this.queueProgress.bytesDone = this.queueProgress.bytesDoneBefore + tPrg.bytesDone;
            this.queueProgress.task.bytesTotal = tPrg.bytesTotal;
            this.queueProgress.task.bytesDone = tPrg.bytesDone;
            this.queueProgress.task.bytesPerSecond = tPrg.bytesPerSecond;
            if (this.queueProgress.timeElapsed > 0) {
                this.queueProgress.bytesPerSecond = this.queueProgress.bytesDone / this.queueProgress.timeElapsed * 1000;
            }
        }
        this.queueProgress.task.clientSummary = tPrg.clientSummary;
        if (tPrg.logLevel > -1) {
            this.taskController.log(tPrg.logLevel, this.queueProgress.currentTask.getMessage());
        }
        this.runProgress(this.queueProgress);
    }
    addProgressCallbacks(lo) {
        if (lo !== null) {
            lo._fnQueueProgress = {
                ctx: this,
                fn: this.onTaskProgress
            };
            lo._fnQueueError = {
                ctx: this,
                fn: this.addError
            };
        }
    }
    getExecutionDurationMS() {
        return this.queueProgress.timeElapsed;
    }
    getExecutionDuration() {
        return this.com.taskSupplier.niceTimeInterval(this.queueProgress.timeElapsed);
    }
    getErrors() {
        return this.arErrors;
    }
    getCurrentBatchContent() {
        return this.currentBatch;
    }
    addTask(cmd, args = null) {
        if (args === null) {
            args = [];
        }
        const qItem = new QueueItem_1.QueueItem(this, this.queueProgress.length, cmd, args);
        this.arQueueItems.push(qItem);
    }
    getResults() {
        return this.results;
    }
    reset(clearQueueCommands = true, clearItems = true) {
        if (!this.bRunning) {
            this.taskController.reset();
            this.nQueuePos = 0;
            this.results = [];
            this.arErrors = [];
            if (clearItems) {
                this.doClearList();
            }
            if (clearQueueCommands) {
                this.arQueueItems = [];
            }
            this.queueProgress.length = this.arQueueItems.length;
            this.queueProgress.percent = 0;
            this.canceled = this.aborted = false;
            this.bError = false;
        }
    }
    getRunning() {
        return (this.bRunning && !this.canceled);
    }
    run() {
        if (this.bRunning) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.queueRunning);
        }
        else {
            this.reset(false, false);
            this.queueProgress.timeStart = FSIServerClientUtils_1.FSIServerClientUtils.NOW();
            this.taskController.logTask(LogLevel_1.LogLevel.info, APITasks_1.APITasks.queueStart, [this.queueProgress.length]);
            this.bRunning = true;
            this.results = new Array(this.queueProgress.length);
            const self = this;
            return new Promise((resolve, reject) => {
                self.runNext(resolve, reject);
            });
        }
    }
    async runWithResult() {
        await this.run()
            .catch(() => {
        })
            .finally(() => {
            this.logErrors();
        });
        return this.getResults();
    }
    logErrors() {
        const errors = this.getErrors();
        if (errors.length > 0) {
            for (const err of errors) {
                this.taskController.log(LogLevel_1.LogLevel.error, "- " + err.message);
            }
        }
    }
    callProgress() {
        if (this.bRunning)
            this.runProgress(this.queueProgress);
    }
    checkAborted() {
        if (!this.aborted && this.abortController.getAborted()) {
            const err = this.com.err.get(APIErrors_1.APIErrors.userAborted);
            this.addError(err);
            this.error(err);
            this.canceled = this.aborted = true;
        }
    }
    async continueOnError(err) {
        const aborted = this.com.isAbortError(err);
        let ret;
        if (!aborted && this.fnPrompt) {
            const errKeys = (err instanceof APIError_1.APIError) ? err.getKeys() : err.message;
            let res = (errKeys) ? this.taskController.getUserDecision(errKeys) : undefined;
            if (res === undefined) {
                const def = (err instanceof APIError_1.APIError) ? err.getMainErrorDef() : undefined;
                const msg = (err instanceof APIError_1.APIError) ? err.getMessage(true) : err.message;
                const buttons = (def && def.buttons) ? def.buttons : ["yes", "always", "no"];
                const tskDef = (def && def.noContinueText === true) ? APITasks_1.APITasks.any : APITasks_1.APITasks.continueAfterError;
                const questionTask = this.com.taskSupplier.get(tskDef, [msg]);
                res = await this.com.prompt(this.options, questionTask, errKeys, buttons, this.taskController);
                this.queueProgress.adjustTimeStart(res.time);
            }
            ret = (res.reply !== "no" && res.reply !== "cancel");
            if (!ret) {
                this.canceled = true;
            }
        }
        else {
            ret = (this.options.continueOnError === true && !aborted);
            this.canceled = !ret;
        }
        return ret;
    }
    runClearList() {
        this.doClearList();
        return new Promise((resolve) => {
            return resolve(true);
        });
    }
    doClearList() {
        this.currentBatch.connectorTypes = {};
        this.currentBatch.entries = [];
        this.currentBatch.clientInfo = new ClientSummaryInfo_1.ClientSummaryInfo();
        this.currentBatch.lists = [];
    }
    error(error) {
        this.taskController.error(error);
    }
    runProgress(prg) {
        prg.calcTotal();
        this.fnProgress.fn.call(this.fnProgress.ctx, prg);
    }
    runSingleBatchTask(fn) {
        const self = this;
        this.batchTask.length = 1;
        this.batchTask.position = 0;
        this.queueProgress.task.percent = 0;
        this.queueProgress.currentTask = this.taskController.getCurrentTask();
        this.runProgress(this.queueProgress);
        this.batchTask.position = 1;
        this.queueProgress.task.percent = 100;
        self.batchTask.running = true;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                try {
                    const res = fn(self);
                    return resolve(res);
                }
                catch (err) {
                    reject(err);
                }
            }, 0);
        });
    }
    onSingleStepBatchDone() {
        this.queueProgress.task.pos = this.queueProgress.length;
        this.queueProgress.task.percent = 100;
        this.runProgress(this.queueProgress);
    }
    runLogBatchContent() {
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.info, APITasks_1.APITasks.logBatchContent);
        return this.runSingleBatchTask(Queue.doRunLogBatchContent);
    }
    runLogBatchContentSummary() {
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.trace, APITasks_1.APITasks.logBatchContentSummary);
        return this.runSingleBatchTask(Queue.doRunLogBatchContentSummary);
    }
    onBatchStart(taskName) {
        this.queueProgress.currentTask = this.taskController.getCurrentTask();
        this.runProgress(this.queueProgress);
        const nLength = this.currentBatch.entries.length;
        this.queueProgress.task.length = nLength;
        this.batchTask = {
            length: nLength,
            lockProgress: false,
            position: 0,
            revPosition: nLength - 1,
            running: true,
            taskName
        };
    }
    beforeBatchTask() {
        this.queueProgress.bDone = false;
        this.queueProgress.currentTask = this.taskController.getCurrentTask();
        this.runProgress(this.queueProgress);
    }
    batchNext() {
        this.abortController.throwIfAborted();
        this.queueProgress.bDone = true;
        this.batchTask.position++;
        this.batchTask.revPosition--;
        this.queueProgress.task.pos = this.batchTask.position;
        if (!this.batchTask.lockProgress) {
            if (this.batchTask.length < 1 || this.batchTask.position === this.batchTask.length) {
                this.queueProgress.task.percent = 100;
            }
            else {
                this.queueProgress.task.percent = 100 * this.batchTask.position / this.batchTask.length;
            }
        }
        else {
            this.queueProgress.task.percent = 0;
        }
        this.runProgress(this.queueProgress);
    }
    onBatchFinished() {
        this.resetByteProgress();
        this.taskController.resetSubTask();
    }
    resetByteProgress() {
        this.queueProgress.bytesTotal = this.queueProgress.task.bytesTotal =
            this.queueProgress.bytesDone = this.queueProgress.task.bytesDone =
                this.queueProgress.bytesDoneBefore = 0;
    }
    setDefaultOptionFunction(opts) {
        opts.abortController = this.abortController;
        if (!opts.fnProgress && this.options.fnProgress) {
            opts.fnProgress = {
                ctx: this,
                fn: this.onTaskProgress
            };
        }
        if (!opts.fnPrompt && this.fnPrompt) {
            opts.fnPrompt = this.fnPrompt;
        }
    }
    runBatchDownLoad(targetPath, options = {}) {
        const self = this;
        const taskDef = (modeNode) ? APITasks_1.APITasks.batchDownload : APITasks_1.APITasks.batchDownloadBrowser;
        this.queueProgress.bytesTotal = -1;
        if (!options.getICCProfile && !options.renderOptions) {
            this.queueProgress.bytesTotal = self.currentBatch.clientInfo.totalSize;
        }
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, taskDef, [this.currentBatch.entries.length, targetPath]);
        this.onBatchStart("batchDownload");
        if (!modeNode && !options.createArchiveOnly) {
            this.batchTask.lockProgress = true;
        }
        this.setDefaultOptionFunction(options);
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchDownload"]));
            }
            else {
                self.nextBatchDownload(self, targetPath, options, resolve, reject);
            }
        });
    }
    nextBatchDownload(self, targetPath, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            this.queueProgress.bytesDoneBefore = this.queueProgress.bytesDone;
            const bc = self.currentBatch;
            const entry = bc.entries[self.batchTask.position];
            if (entry.type !== "file" && !options.archiveType) {
                self.batchNext();
                return self.nextBatchDownload(self, targetPath, options, fnResolve, fnReject);
            }
            self.queueProgress.task.bytesDone = 0;
            self.queueProgress.task.bytesTotal = (this.queueProgress.bytesTotal === -1) ? 0 : entry.size;
            if (options.fnRename) {
                options.fileName = options.fnRename(entry);
            }
            const orgQueued = options.queued;
            options.queued = true;
            const promise = self.client.download(entry, targetPath, options, this.taskController);
            self.beforeBatchTask();
            promise
                .then(() => {
                self.queueProgress.task.bytesDone = self.queueProgress.task.bytesTotal;
                self.batchNext();
                self.nextBatchDownload(self, targetPath, options, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchDownload(self, targetPath, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            })
                .finally(() => {
                if (orgQueued === undefined) {
                    delete options.queued;
                }
                else {
                    options.queued = orgQueued;
                }
            });
        }
        else {
            if (!modeNode || options.createArchiveOnly) {
                this.batchTask.length = 1;
                this.batchTask.position = 0;
                this.queueProgress.task.percent = 0;
                const download = new Download_1.Download(self.classInit, this.taskController);
                let promise;
                if (options.createArchiveOnly) {
                    promise = download.createDownloadArchive(options, false);
                }
                else {
                    promise = download.createAndDownloadArchive(options);
                }
                promise
                    .then((downloadID) => {
                    if (options.fnOnArchiveID) {
                        options.fnOnArchiveID.fn.call(options.fnOnArchiveID.ctx, downloadID);
                    }
                    this.onBatchFinished();
                    fnResolve(downloadID);
                })
                    .catch(fnReject);
            }
            else {
                this.onBatchFinished();
                fnResolve(true);
            }
        }
    }
    runBatchUpload(targetPath, options = {}) {
        const self = this;
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchUpload, [this.currentBatch.entries.length, targetPath]);
        this.onBatchStart("batchUpload");
        this.queueProgress.bytesTotal = this.currentBatch.clientInfo.totalSize;
        this.setDefaultOptionFunction(options);
        return new Promise((resolve, reject) => {
            if (self.batchContainsNonLocalFiles()) {
                return reject(self.com.err.get(APIErrors_1.APIErrors.batchNonLocalFiles, ["batchUpload"]));
            }
            else {
                self.nextBatchUpload(self, targetPath, options, resolve, reject);
            }
        });
    }
    nextBatchUpload(self, targetPath, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            this.queueProgress.bytesDoneBefore = this.queueProgress.bytesDone;
            const bc = self.currentBatch;
            const entry = bc.entries[self.batchTask.position];
            if (entry.type !== "file" && entry.type !== "directory") {
                self.batchNext();
                return self.nextBatchUpload(self, targetPath, options, fnResolve, fnReject);
            }
            self.queueProgress.task.bytesDone = 0;
            self.queueProgress.task.bytesTotal = entry.size;
            const promise = self.client.upload(entry, targetPath, options, self.taskController);
            self.beforeBatchTask();
            promise
                .then(() => {
                self.queueProgress.task.bytesDone = self.queueProgress.task.bytesTotal;
                self.batchNext();
                self.nextBatchUpload(self, targetPath, options, fnResolve, fnReject);
                return;
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchUpload(self, targetPath, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    runBatchReimport(image = true, metaData = true, httpOptions = {}) {
        const self = this;
        this.setDefaultOptionFunction(httpOptions);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchReImport, [this.currentBatch.entries.length]);
        this.onBatchStart("batchReImport");
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchReImport"]));
            }
            else {
                self.nextBatchReImport(self, image, metaData, httpOptions, 0, resolve, reject);
            }
        });
    }
    nextBatchReImport(self, image, metaData, httpOptions, count, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[self.batchTask.position];
            const basePath = entry._listData.summary.dir;
            const curName = entry.src;
            const service = (entry.type === "file") ? "file" : "directory";
            let promise;
            if (service === "file") {
                promise = self.client.reImportFile(basePath + curName, image, metaData, httpOptions, this.taskController);
            }
            else {
                promise = self.client.reImportDir(basePath + curName, image, metaData, httpOptions, this.taskController);
            }
            self.beforeBatchTask();
            promise.then(() => {
                count++;
                self.batchNext();
                self.nextBatchReImport(self, image, metaData, httpOptions, count, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchReImport(self, image, metaData, httpOptions, count, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(count);
        }
    }
    runBatchMove(newPath) {
        const self = this;
        newPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(newPath);
        const fnRename = (entry) => {
            return new Promise((resolve) => {
                const reg = new RegExp("^" + FSIServerClientUtils_1.FSIServerClientUtils.ESCAPE_REG_EX(entry._listData.summary._baseDir));
                const result = entry.path.replace(reg, newPath);
                return resolve(result);
            });
        };
        return new Promise((resolve, reject) => {
            this.client.createDirectory(newPath, {
                abortController: self.abortController,
                overwrite: true
            }, self.taskController)
                .then(() => {
                this.runBatchRename(fnRename, true)
                    .then(resolve)
                    .catch(reject);
            })
                .catch(reject);
        });
    }
    runBatchRename(fnRename, move = false) {
        const self = this;
        const task = (move) ? APITasks_1.APITasks.batchMove : APITasks_1.APITasks.batchRename;
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, task, [this.currentBatch.entries.length]);
        this.onBatchStart("batchRename");
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                const taskName = (move) ? "batchMove" : "batchRename";
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, [taskName]));
            }
            else {
                self.nextBatchRename(self, fnRename, resolve, reject, move)
                    .catch(reject);
            }
        });
    }
    async nextBatchRename(self, fnRename, fnResolve, fnReject, move) {
        let finalPath = "";
        let reply = "";
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[self.batchTask.revPosition];
            const basePath = entry._listData.summary.dir;
            let curName = (move) ? entry.path : entry.src;
            let newName = await fnRename(entry);
            const service = (entry.type === "file") ? "file" : "directory";
            let promise;
            const onFileExists = async (httpStatus) => {
                const taskDef = (entry.type === "file") ? APITasks_1.APITasks.overwriteTargetFile : APITasks_1.APITasks.overwriteTargetDirectory;
                const owReply = await this.handleFileExists(finalPath, httpStatus, taskDef);
                reply = owReply.reply;
                return owReply;
            };
            if (curName === newName) {
                this.taskController.setCurrentSubTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.skipping, [basePath + curName]);
                promise = FSIServerClientInterface_1.FSIServerClientInterface.GET_TRUE_PROMISE();
            }
            else {
                if (!move) {
                    curName = basePath + curName;
                    newName = basePath + newName;
                }
                finalPath = newName;
                if (service === "file") {
                    if (move) {
                        promise = self.client.moveFile(curName, newName, {
                            abortController: self.abortController,
                            handleIgnoredError: onFileExists,
                            ignoreErrors: { 409: true },
                            overwrite: false,
                        }, self.taskController);
                    }
                    else {
                        promise = self.client.renameFile(curName, newName, { abortController: self.abortController }, self.taskController);
                    }
                }
                else {
                    if (move) {
                        promise = self.client.moveDirectory(curName, newName, {
                            abortController: self.abortController,
                            handleIgnoredError: onFileExists,
                            ignoreErrors: { 409: true }
                        }, self.taskController);
                    }
                    else {
                        promise = self.client.renameDirectory(curName, newName, { abortController: self.abortController }, self.taskController);
                    }
                }
            }
            self.beforeBatchTask();
            promise.then(async () => {
                if (reply) {
                    if (reply === "cancel") {
                        return fnReject(self.com.err.get(APIErrors_1.APIErrors.userAborted));
                    }
                    else if (reply === "overwrite") {
                        try {
                            if (service === "file") {
                                await self.client.moveFile(curName, newName, {
                                    abortController: self.abortController,
                                    overwrite: true
                                }, self.taskController);
                            }
                            else {
                                await self.client.deleteDirectory(newName, {}, self.taskController);
                                await self.client.moveDirectory(curName, newName, {
                                    abortController: self.abortController
                                }, self.taskController);
                            }
                        }
                        catch (err) {
                            return fnReject(err);
                        }
                    }
                }
                self.batchNext();
                await self.nextBatchRename(self, fnRename, fnResolve, fnReject, move);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    await self.nextBatchRename(self, fnRename, fnResolve, fnReject, move);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    runBatchGetMetaData(options = {}) {
        const self = this;
        this.setDefaultOptionFunction(options);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchGetMateData, [this.currentBatch.entries.length]);
        this.onBatchStart("batchGetMetaData");
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchGetMetaData"]));
            }
            else {
                self.nextBatchGetMetaData(self, options, resolve, reject);
            }
        });
    }
    nextBatchGetMetaData(self, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[pos];
            const promise = self.client.getMetaData(entry.path, options, self.taskController);
            self.beforeBatchTask();
            promise.then((meta) => {
                entry.metaData = meta;
                self.batchNext();
                self.nextBatchGetMetaData(self, options, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchGetMetaData(self, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    runBatchSendServiceCommands(service, command, options = {}) {
        const self = this;
        this.setDefaultOptionFunction(options);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchSendServiceCommands, [command, this.currentBatch.entries.length, service]);
        this.onBatchStart("batchSendServiceCommands");
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchSendServiceCommands"]));
            }
            else {
                self.nextBatchSendServiceCommands(self, service, command, options, resolve, reject);
            }
        });
    }
    nextBatchSendServiceCommands(self, service, command, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[pos];
            const promise = self.client.sendServiceCommand(entry.src, service, command, options, this.taskController);
            self.beforeBatchTask();
            promise.then(() => {
                self.batchNext();
                self.nextBatchSendServiceCommands(self, service, command, options, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchSendServiceCommands(self, service, command, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    runBatchSetMetaData(data, cmd = "saveMetaData", options = {}) {
        const self = this;
        this.setDefaultOptionFunction(options);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchSetMetaData, [this.currentBatch.entries.length]);
        this.onBatchStart("batchSetMetaData");
        if (typeof (data) === "function") {
            return new Promise((resolve, reject) => {
                if (this.batchContainsLocalFiles()) {
                    return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchSetMetaData"]));
                }
                else {
                    self.nextBatchSetMetaDataDynamic(self, cmd, data, options, resolve, reject);
                }
            });
        }
        else {
            return new Promise((resolve, reject) => {
                if (this.batchContainsLocalFiles()) {
                    return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchSetMetaData"]));
                }
                else {
                    self.nextBatchSetMetaData(self, MetaDataClient_1.MetaDataClient.GET_META_QUERY(data, cmd), options, resolve, reject);
                }
            });
        }
    }
    nextBatchSetMetaDataDynamic(self, cmd, fnMeta, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[pos];
            const promise = new MetaDataClient_1.MetaDataClient(self.classInit, this.taskController).setByFunction(entry, cmd, fnMeta, options);
            promise.then(() => {
                self.batchNext();
                self.nextBatchSetMetaDataDynamic(self, cmd, fnMeta, options, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchSetMetaDataDynamic(self, cmd, fnMeta, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    nextBatchSetMetaData(self, query, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[pos];
            const promise = this.taskController.wrapPromise(new MetaDataClient_1.MetaDataClient(this.classInit, this.taskController)
                .setWithQuery(entry.path, entry.type, query, options));
            self.beforeBatchTask();
            promise.then(() => {
                self.batchNext();
                self.nextBatchSetMetaData(self, query, options, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchSetMetaData(self, query, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    runBatchDelete(options) {
        const self = this;
        this.setDefaultOptionFunction(options);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchDelete, [this.currentBatch.entries.length]);
        this.onBatchStart("batchDelete");
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchDelete"]));
            }
            else {
                self.nextBatchDelete(self, options, resolve, reject);
            }
        });
    }
    nextBatchDelete(self, options, fnResolve, fnReject) {
        const pos = self.batchTask.position;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            const entry = bc.entries[self.batchTask.revPosition];
            const basePath = entry._listData.summary.dir;
            const path = basePath + entry.src;
            const service = (entry.type === "file") ? "file" : "directory";
            let promise;
            if (service === "file") {
                promise = self.client.deleteFile(path, options, self.taskController);
            }
            else {
                promise = self.client.deleteDirectory(path, options, self.taskController);
            }
            self.beforeBatchTask();
            promise.then(() => {
                self.batchNext();
                self.nextBatchDelete(self, options, fnResolve, fnReject);
            })
                .catch(async (err) => {
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchDelete(self, options, fnResolve, fnReject);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(true);
        }
    }
    runBatchCopy(targetPath, options) {
        const self = this;
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.batchCopy, [this.currentBatch.entries.length]);
        this.onBatchStart("batchCopy");
        if (options.autoRename && !options.fnRename)
            options.autoRename = false;
        return new Promise((resolve, reject) => {
            if (this.batchContainsLocalFiles()) {
                return reject(this.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["batchCopy"]));
            }
            else {
                self.nextBatchCopy(self, targetPath, options, resolve, reject, []);
            }
        });
    }
    getSkipOverwriteReply() {
        return new Promise((resolve) => {
            return resolve({ "reply": "Retrying", "continue": true });
        });
    }
    nextBatchCopy(self, targetPath, options, fnResolve, fnReject, copiedEntries, tries = 0) {
        const pos = self.batchTask.position;
        let abort = false;
        const autoRenameRetries = options.autoRenameRetries || 500;
        if (pos < self.batchTask.length) {
            const bc = self.currentBatch;
            let reply = "";
            const entry = bc.entries[pos];
            const basePath = entry._listData.summary.dir;
            const path = basePath + entry.src;
            const service = (entry.type === "file") ? "file" : "directory";
            let promise;
            const finalPath = FSIServerClientUtils_1.FSIServerClientUtils.GET_NEW_RELATIVE_PATH(path, entry._listData.summary._baseDir, targetPath, entry, options, tries);
            const onFileExists = async (httpStatus) => {
                if (options.autoRename && tries < autoRenameRetries) {
                    abort = true;
                    self.nextBatchCopy(self, targetPath, options, fnResolve, fnReject, copiedEntries, ++tries);
                    return self.getSkipOverwriteReply();
                }
                const owReply = await this.handleFileExists(finalPath, httpStatus, APITasks_1.APITasks.overwriteTargetFile);
                reply = owReply.reply;
                return owReply;
            };
            if (service === "file") {
                self.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.copyFile, [path, finalPath]);
                promise = new FileOps_1.FileOps(self.classInit, this.taskController).copyFile(path, finalPath, {
                    abortController: self.abortController,
                    handleIgnoredError: onFileExists,
                    ignoreErrors: { 409: true }
                });
            }
            else {
                promise = self.client.createDirectory(finalPath, {
                    abortController: self.abortController,
                    overwrite: options.autoRename !== true
                }, self.taskController);
            }
            self.beforeBatchTask();
            promise.then(async () => {
                if (abort)
                    return false;
                if (reply) {
                    if (reply === "cancel") {
                        return fnReject(self.com.err.get(APIErrors_1.APIErrors.userAborted));
                    }
                    else if (reply === "overwrite") {
                        try {
                            await new FileOps_1.FileOps(self.classInit, self.taskController).copyFile(path, finalPath, { overwrite: true });
                        }
                        catch (err) {
                            return fnReject(err);
                        }
                    }
                }
                const copiedEntry = index_1.ListServer.CLONE_LIST_ENTRY(entry);
                copiedEntry.path = finalPath;
                const pdCopied = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(finalPath);
                copiedEntry.src = pdCopied.dir;
                copiedEntries.push(copiedEntry);
                self.batchNext();
                self.nextBatchCopy(self, targetPath, options, fnResolve, fnReject, copiedEntries);
            })
                .catch(async (err) => {
                if (service === "directory" && options.autoRename === true && tries < autoRenameRetries) {
                    self.nextBatchCopy(self, targetPath, options, fnResolve, fnReject, copiedEntries, ++tries);
                    return false;
                }
                if (await self.continueOnError(err)) {
                    self.batchNext();
                    self.addError(err);
                    self.error(err);
                    self.nextBatchCopy(self, targetPath, options, fnResolve, fnReject, copiedEntries);
                }
                else {
                    fnReject(err);
                }
            });
        }
        else {
            this.onBatchFinished();
            fnResolve(copiedEntries);
        }
    }
    getMethod(itm) {
        const queueMethod = this.queueMethods[itm.cmd];
        return queueMethod.fn.apply(queueMethod.ctx, itm.args);
    }
    addError(err) {
        this.arErrors.push(err);
        this.bError = true;
    }
    onStopExecution() {
        this.abortController.release();
        this.bRunning = false;
        this.taskController.logTask(LogLevel_1.LogLevel.info, APITasks_1.APITasks.queueFinished, [this.arErrors.length, this.getExecutionDuration()]);
        if (this.arErrors.length > 0 && this.options.continueOnError !== true) {
            this.error(this.com.err.get(APIErrors_1.APIErrors.queueStoppedWithErrors));
        }
    }
    onCustomProgress(taskDescription, pos = 0, length) {
        this.queueProgress.currentTask.setSubTask(APITasks_1.APITasks.startQueueCommand, [(pos + 1), length, taskDescription]);
        this.batchTask.length = length;
        this.batchTask.position = pos;
        if (this.batchTask.length < 1 || this.batchTask.position === this.batchTask.length) {
            this.queueProgress.task.percent = 100;
        }
        else {
            this.queueProgress.task.percent = 100 * this.batchTask.position / this.batchTask.length;
        }
        this.runProgress(this.queueProgress);
    }
    runNext(fnResolve, fnReject) {
        this.taskController.reset();
        this.queueProgress.bytesTotal = 0;
        this.checkAborted();
        const curQueuePos = this.nQueuePos++;
        if (curQueuePos < this.queueProgress.length) {
            this.taskController.resetUserDecisions();
            this.iCurrentItem = this.arQueueItems[curQueuePos];
            this.queueProgress.task = new TaskProgress_1.TaskProgress();
            this.batchTask.lockProgress = true;
            this.queueProgress.bDone = false;
            this.queueProgress.pos = (curQueuePos + 1);
            this.queueProgress.currentItem = this.iCurrentItem;
            this.queueProgress.currentTask = this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.startQueueCommand, [this.queueProgress.pos, this.queueProgress.length, this.iCurrentItem.cmd]);
            let listOptions = null;
            switch (this.iCurrentItem.cmd) {
                case "listServer":
                case "listLocal":
                    if (typeof (this.iCurrentItem.args[1]) === "object"
                        && this.iCurrentItem.args[1].recursive) {
                        listOptions = this.iCurrentItem.args[1];
                        listOptions.continueOnError = this.options.continueOnError;
                    }
                    break;
                case "download":
                    if (typeof (this.iCurrentItem.args[2]) !== "object") {
                        this.iCurrentItem.args[2] = {};
                    }
                    this.iCurrentItem.args[2].oProgress = {
                        ctx: this,
                        fn: this.onTaskProgress
                    };
                    break;
                case "addEntries":
                case "addEntryObjects":
                    if (typeof (this.iCurrentItem.args[1]) === "object") {
                        listOptions = this.iCurrentItem.args[1];
                        listOptions.continueOnError = this.options.continueOnError;
                    }
            }
            this.addProgressCallbacks(listOptions);
            this.taskController.reset();
            const promise = this.getMethod(this.iCurrentItem);
            this.queueProgress.currentTask = this.taskController.getCurrentTask();
            if (!this.batchTask.running) {
                this.runProgress(this.queueProgress);
            }
            promise
                .then(body => {
                this.results[curQueuePos] = body;
                if (!this.batchTask.running) {
                    this.queueProgress.bDone = true;
                    this.queueProgress.task.pos = this.queueProgress.task.length;
                    this.queueProgress.task.percent = 100;
                    this.queueProgress.bDone = true;
                    this.runProgress(this.queueProgress);
                }
                else {
                    this.queueProgress.bDone = true;
                    this.runProgress(this.queueProgress);
                }
                if (this.iCurrentItem.cmd.indexOf("list") === 0 && typeof (body) === "object") {
                    const ld = body;
                    this.appendListData(ld);
                }
                return this.runNext(fnResolve, fnReject);
            })
                .catch(async (error) => {
                this.checkAborted();
                if (!this.canceled) {
                    if (!(error instanceof APIError_1.APIError) && (!error.type || error.type !== "aborted")) {
                        console.error(error);
                    }
                    else {
                        this.error(error);
                    }
                    this.addError(error);
                }
                if (!this.canceled && await this.continueOnError(error)) {
                    this.runNext(fnResolve, fnReject);
                }
                else {
                    this.onStopExecution();
                    this.canceled = true;
                    fnReject(this.com.err.get(APIErrors_1.APIErrors.queueStoppedWithErrors));
                }
            }).finally(() => {
                this.batchTask.running = false;
            });
        }
        else {
            this.onStopExecution();
            fnResolve(!this.bError);
        }
    }
    appendListData(ld) {
        this.currentBatch.lists.push(ld);
        const connectorType = ld.summary.connectorType;
        if (this.currentBatch.connectorTypes[connectorType] === undefined) {
            this.currentBatch.connectorTypes[connectorType] = ld.summary.entryCount;
        }
        else {
            this.currentBatch.connectorTypes[connectorType] += ld.summary.entryCount;
        }
        this.currentBatch.entries = this.currentBatch.entries.concat(ld.entries);
        this.currentBatch.clientInfo.entryCount += ld.summary.clientInfo.entryCount;
        this.currentBatch.clientInfo.fileCount += ld.summary.clientInfo.fileCount;
        this.currentBatch.clientInfo.directoryCount += ld.summary.clientInfo.directoryCount;
        this.currentBatch.clientInfo.maxDepth = Math.max(this.currentBatch.clientInfo.maxDepth, ld.summary.clientInfo.maxDepth);
        this.currentBatch.clientInfo.note = ld.summary.clientInfo.note;
        this.currentBatch.clientInfo.totalSize += ld.summary.clientInfo.totalSize;
        for (let i = 0; i < 6; i++) {
            this.currentBatch.clientInfo.importStates[i] += ld.summary.clientInfo.importStates[i];
        }
    }
    batchContainsNonLocalFiles() {
        for (const connectorType of Object.keys(this.currentBatch.connectorTypes)) {
            if (connectorType !== "LOCAL" && this.currentBatch.connectorTypes[connectorType] > 0) {
                return true;
            }
        }
        return false;
    }
    batchContainsLocalFiles() {
        return (this.currentBatch.connectorTypes.LOCAL !== undefined && this.currentBatch.connectorTypes.LOCAL > 0);
    }
    runAddEntries(paths, options) {
        this.setDefaultOptionFunction(options);
        const self = this;
        return new Promise((resolve, reject) => {
            if (self.batchContainsLocalFiles()) {
                return reject(self.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["runAddEntries"]));
            }
            else {
                self.client.addEntries(paths, options, self.taskController)
                    .then(body => {
                    const lists = body;
                    for (const list of lists) {
                        self.appendListData(list);
                    }
                    return resolve(lists);
                })
                    .catch((err) => {
                    return reject(err);
                });
            }
        });
    }
    runAddEntryObjects(entries, options, addOptions) {
        this.setDefaultOptionFunction(options);
        const self = this;
        return new Promise((resolve, reject) => {
            if (self.batchContainsLocalFiles()) {
                return reject(self.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["runAddEntryObjects"]));
            }
            else {
                self.client.addEntryObjects(entries, options, addOptions, self.taskController)
                    .then(body => {
                    const lists = body;
                    for (const list of lists) {
                        self.appendListData(list);
                    }
                    return resolve(lists);
                })
                    .catch((err) => {
                    return reject(err);
                });
            }
        });
    }
    runAddDirectoryContent() {
        const self = this;
        return new Promise(async (resolve, reject) => {
            if (self.batchContainsLocalFiles()) {
                return reject(self.com.err.get(APIErrors_1.APIErrors.batchLocalFiles, ["runAddDirectoryContent"]));
            }
            else {
                let n = -1;
                const nEnd = this.currentBatch.entries.length;
                const getNext = () => {
                    n++;
                    if (n === nEnd) {
                        return resolve(true);
                    }
                    const entry = this.currentBatch.entries[n];
                    if (entry.type !== "directory") {
                        return getNext();
                    }
                    let baseDir;
                    if (entry.path.indexOf("/") === -1) {
                        baseDir = entry._listData.summary.dir;
                    }
                    else {
                        baseDir = FSIServerClientUtils_1.FSIServerClientUtils.GET_PARENT_PATH(entry.path);
                    }
                    self.client.listServer(entry.path, {
                        recursive: true,
                        baseDir,
                        readInternalConnectors: true,
                        abortController: self.abortController,
                        continueOnError: self.options.continueOnError
                    }, self.taskController)
                        .then((list) => {
                        self.appendListData(list);
                        getNext();
                    })
                        .catch(err => {
                        return reject(err);
                    });
                };
                getNext();
            }
        });
    }
    runCustomTask(scope, fn, ...args) {
        if (typeof (args) !== "object" || typeof (args.concat) !== "function")
            args = [];
        args.unshift(this.onCustomProgress);
        args.unshift(this);
        args.unshift(this.client);
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                fn.apply(scope, args)
                    .then((ret) => {
                    return resolve(ret);
                })
                    .catch(err => {
                    return reject(err);
                });
            }, 0);
        });
    }
    async handleFileExists(finalPath, httpStatus, taskDef) {
        if (httpStatus === 409) {
            const pf = this.client.getPromptFunction();
            if (!pf) {
                return {
                    continue: false,
                    reply: ""
                };
            }
            else {
                let res = this.taskController.getUserDecision("file.overwrite");
                if (res === undefined) {
                    const task = this.com.taskSupplier.get(taskDef, [finalPath]);
                    res = await this.com.prompt(this.options, task, "file.overwrite", [
                        "cancel",
                        "overwrite",
                        "overwriteAll",
                        "skip",
                        "skipAll"
                    ], this.taskController);
                    this.queueProgress.adjustTimeStart(res.time);
                }
                return {
                    continue: true,
                    reply: res.reply
                };
            }
        }
        else {
            return {
                continue: false,
                reply: ""
            };
        }
    }
}
exports.Queue = Queue;
